module.exports = "/fonts/vendor/summernote/dist/summernote.woff2?265e4cbaa04991d0d14ad908780835e9";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.woff2
// module id = 89
// module chunks = 0